import { makeStyles } from "@material-ui/core";

/**
 * @interface StyleProps
 */
export interface StyleProps {
  monoMode: boolean;
  disabled?: boolean;
}

/**
 * @function useStyles
 * @param {StyleProps} props
 */
export const useCheckboxStyles = makeStyles({
  small: {
    transform: "scale(0.75)",
  },
  large: {},
  icon: {
    width: 30,
    height: 30,
    transition: "opacity 300ms, border 300ms",
  },
  checkedIcon: {
    width: 29,
    height: 15,
    position: "absolute",
    transform: "rotate(-45deg)",
    transition: "border-color 300ms, background-color 300ms",
    border: (props: StyleProps) =>
      props.disabled
        ? ".1875rem solid #a2a2a2"
        : props.monoMode
          ? ".1875rem solid #000"
          : ".1875rem solid var(--secondary-color)",
    borderTop: (props: StyleProps) => (props.monoMode ? "none" : "none"),
    borderRight: (props: StyleProps) => (props.monoMode ? "none" : "none"),
    top: "0rem",
    left: ".1875rem",
  },
});
